import * as React from "react";
import * as HoverCardPrimitive from "@radix-ui/react-hover-card";
import { cn } from "../../lib/utils";

/**
 * shadcn/ui HoverCard (Radix), in the AeroVect palette.
 *
 * Tooltip's bigger sibling. A Tooltip carries a sentence about the thing under
 * the cursor; this carries a small panel — a ticket list, a staleness
 * breakdown — that opens on hover-with-intent and stays open while the pointer
 * travels into it to read.
 *
 * Hover-only by nature: it never opens on touch. Anything shown here must also
 * be reachable somewhere click-based — for the fleet table that is the row
 * expansion and the tractor page, which is why the cards can stay read-only
 * previews rather than growing links of their own.
 */
const HoverCard = HoverCardPrimitive.Root;
const HoverCardTrigger = HoverCardPrimitive.Trigger;

const HoverCardContent = React.forwardRef<
  React.ElementRef<typeof HoverCardPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Content>
>(({ className, align = "start", sideOffset = 6, ...props }, ref) => (
  <HoverCardPrimitive.Portal>
    <HoverCardPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        "z-overlay w-72 rounded-lg border border-line bg-white p-3 font-sans text-[12.5px] leading-snug text-ink shadow-md outline-none data-[state=open]:animate-in motion-reduce:animate-none data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        className,
      )}
      {...props}
    />
  </HoverCardPrimitive.Portal>
));
HoverCardContent.displayName = "HoverCardContent";

export { HoverCard, HoverCardTrigger, HoverCardContent };
